import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Container, Typography, Button, Alert, CircularProgress } from '@mui/material';
import ArrowIcon from '@mui/icons-material/ArrowForwardOutlined';

import { useLector } from '../config/lector';
import { useAuth } from '../auth/AuthProvider';
import { useTranslation } from 'react-i18next';
import './entrar.css';

const EntrarPage = () => {
  const { t } = useTranslation();
  const { identificado, lector, ready } = useLector();
  const { login, error } = useAuth();

  if (identificado) {
    return (
      <Box className="ent">
        <Container maxWidth="sm">
          <Typography variant="h1" className="ent-h1">{t('entrar.ya_entraste')}</Typography>
          <Typography className="ent-bajada">
            {t('entrar.dentro_como')} <strong>{lector.nombre || lector.correo}</strong>.
          </Typography>
          <RouterLink to="/cuenta" className="ent-enlace-fuerte">
            {t('entrar.ir_cuenta')} <ArrowIcon fontSize="inherit" />
          </RouterLink>
        </Container>
      </Box>
    );
  }

  const errorKey = error && error.message === 'auth_not_configured' ? 'entrar.auth_no_disponible' : 'entrar.no_completo';

  return (
    <Box className="ent">
      <Container maxWidth="sm">
        <Typography variant="h1" className="ent-h1">{t('menu.entrar')}</Typography>
        <Typography className="ent-bajada">{t('entrar.bajada_entrar')}</Typography>

        <Box className="ent-campos">
          {error && <Alert severity="error" className="ent-error">{t(errorKey)}</Alert>}

          <Button className="ent-enviar" onClick={login} disabled={!ready}>
            {ready ? t('entrar.ingresar') : <CircularProgress size={20} sx={{ color: 'inherit' }} />}
          </Button>
          <Button className="ent-google" onClick={login} disabled={!ready}>
            {t('entrar.crear_mi_cuenta')}
          </Button>
        </Box>

        <Typography className="ent-legal">
          {t('entrar.legal_entrar')}{' '}
          <RouterLink to="/privacidad">{t('entrar.como_tratamos')}</RouterLink>
        </Typography>
      </Container>
    </Box>
  );
};

export default EntrarPage;
